/**
 * Legacy TextVariablesApiService module — preserved as an empty AngularJS
 * module so existing dependencies (`acme.common.service.textVariablesApi`)
 * keep resolving.
 *
 * The actual TextVariablesApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/text-variables/text-variables-api.service.ts
 */
angular.module("acme.common.service.textVariablesApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
